// src/api/axios.js
import axios from "axios"
import { toast } from "react-toastify"
import { getToken } from "utils/helpersUtils"

// Detect user's timezone dynamically
const getCurrentTimezone = () =>
  Intl.DateTimeFormat().resolvedOptions().timeZone

const apiClient = axios.create({
  // baseURL: "http://localhost:8000/api", // Your Laravel API URL
  baseURL: process.env.REACT_APP_API, // Your Laravel API URL
  withCredentials: true, // Important for sessions/cookies if you use Sanctum
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
})

// Use a request interceptor to dynamically add the Authorization header
apiClient.interceptors.request.use(
  config => {
    // Retrieve the token from local storage
    const token = getToken()

    // If a token exists, add it to the request headers
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    // ✅ Add dynamic timezone header
    config.headers["X-Timezone"] = getCurrentTimezone()
    config.headers["X-Date"] = new Date().toISOString();

    return config // Important: return the config object
  },
  error => {
    // Handle request errors
    return Promise.reject(error)
  }
)

// ✅ Response interceptor for handling errors globally
apiClient.interceptors.response.use(
  response => {
    // Any status code that lie within the range of 2xx cause this function to trigger
    return response
  },
  error => {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    let errorMessage = "An unexpected error occurred."

    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      const status = error.response.status
      const dataMessage = error.response.data?.message

      if (status === 401) {
        errorMessage = dataMessage || "Unauthorized. Please log in again."
        // Optionally, dispatch a logout action here
      } else if (status === 403) {
        errorMessage = dataMessage || "Forbidden. You don't have permission."
      } else if (status === 404) {
        errorMessage = dataMessage || "Resource not found."
      } else if (status >= 500) {
        errorMessage =
          dataMessage || "A server error occurred. Please try again later."
      } else if (dataMessage) {
        errorMessage = dataMessage
      }
    } else if (error.request) {
      // The request was made but no response was received (e.g., network error)
      errorMessage = "Network error. Please check your connection."
    }

    // ✅ Only show toast if request doesn't explicitly disable it
    if (!error.config?.skipToast) {
      toast.error(errorMessage)
    }

    // It's important to reject the promise to allow individual .catch() blocks to run
    return Promise.reject(error)
  }
)

export default apiClient
